// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header {
  height: 32px;
  display: block;
  overflow: visible;
  background: #232f3e;
}

#global-search {
  background-color: #232F3E;
}

html, body{
  background: #F3F3F3;
  /* font-size: 10px; */
  font-family: 'Amazon Ember', Helvetica, Arial, sans-serif;
  line-height: 1.4em;
  min-width: 400px;
  padding:0;
  height: 100%;
  overflow: hidden;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html, body, #root {
  height: 100%;
  background-color: #333333;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.awsui {
  height: calc(100vh - 50px);
  overflow-x: hidden;
}

.testcontent {
  height: 1000px;
  border: 1px red dashed;
}

.small-blue-anchor { 
  font-size: small;
  color:#0000EE;
}

.small-blue-anchor:visited{
  font-size: small;
  color:#0000EE;
}

.headerDropdown button{
  background-color: transparent !important;
  background: transparent !important;
  color: #F3F3F3;
  border-color: transparent !important;
}

/* Little icon to the right of text */
.headerDropdown button span{
  background-color: transparent !important;
  background: transparent !important;
  color: #D5DBDB !important;
  border: none;
}

.headerDropdown:hover button span {
  color: #FFFFFF !important;
}

.headerDropdown button[aria-expanded="true"] span{
  color: #f8991d !important
}

.floatRight {
  float: right;
}

/*This is done to prevent FOUC (Flash of Unstyled Content) */
#base_app{
  visibility:visible !important;
}

.primaryIconButton {
  color: #f8991d !important
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yDAAyD;EACzD,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE;aACW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,cAAc;EACd,oCAAoC;AACtC;;AAEA,qCAAqC;AACrC;EACE,wCAAwC;EACxC,kCAAkC;EAClC,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;AACd;;AAEA,4DAA4D;AAC5D;EACE,6BAA6B;AAC/B;;AAEA;EACE;AACF","sourcesContent":["#header {\n  height: 32px;\n  display: block;\n  overflow: visible;\n  background: #232f3e;\n}\n\n#global-search {\n  background-color: #232F3E;\n}\n\nhtml, body{\n  background: #F3F3F3;\n  /* font-size: 10px; */\n  font-family: 'Amazon Ember', Helvetica, Arial, sans-serif;\n  line-height: 1.4em;\n  min-width: 400px;\n  padding:0;\n  height: 100%;\n  overflow: hidden;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nhtml, body, #root {\n  height: 100%;\n  background-color: #333333;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.awsui {\n  height: calc(100vh - 50px);\n  overflow-x: hidden;\n}\n\n.testcontent {\n  height: 1000px;\n  border: 1px red dashed;\n}\n\n.small-blue-anchor { \n  font-size: small;\n  color:#0000EE;\n}\n\n.small-blue-anchor:visited{\n  font-size: small;\n  color:#0000EE;\n}\n\n.headerDropdown button{\n  background-color: transparent !important;\n  background: transparent !important;\n  color: #F3F3F3;\n  border-color: transparent !important;\n}\n\n/* Little icon to the right of text */\n.headerDropdown button span{\n  background-color: transparent !important;\n  background: transparent !important;\n  color: #D5DBDB !important;\n  border: none;\n}\n\n.headerDropdown:hover button span {\n  color: #FFFFFF !important;\n}\n\n.headerDropdown button[aria-expanded=\"true\"] span{\n  color: #f8991d !important\n}\n\n.floatRight {\n  float: right;\n}\n\n/*This is done to prevent FOUC (Flash of Unstyled Content) */\n#base_app{\n  visibility:visible !important;\n}\n\n.primaryIconButton {\n  color: #f8991d !important\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
